/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ActionStatusEnumType } from "./ActionStatusEnum"
import { RootStoreType } from "./index"


/**
 * EngineActionDtoBase
 * auto generated base class for the model EngineActionDtoModel.
 */
export const EngineActionDtoModelBase = ModelBase
  .named('EngineActionDto')
  .props({
    __typename: types.optional(types.literal("EngineActionDto"), "EngineActionDto"),
    actionUuid: types.identifier,
    name: types.union(types.undefined, types.string),
    projectId: types.union(types.undefined, types.integer),
    userUuid: types.union(types.undefined, types.string),
    input: types.union(types.undefined, types.null, types.string),
    undo: types.union(types.undefined, types.null, types.boolean),
    redo: types.union(types.undefined, types.null, types.boolean),
    status: types.union(types.undefined, ActionStatusEnumType),
    failReason: types.union(types.undefined, types.null, types.string),
    receivedAt: types.union(types.undefined, types.null, types.string),
    createdAt: types.union(types.undefined, types.null, types.string),
    organizationId: types.union(types.undefined, types.integer),
    startDate: types.union(types.undefined, types.string),
    endDate: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class EngineActionDtoModelSelector extends QueryBuilder {
  get actionUuid() { return this.__attr(`actionUuid`) }
  get name() { return this.__attr(`name`) }
  get projectId() { return this.__attr(`projectId`) }
  get userUuid() { return this.__attr(`userUuid`) }
  get input() { return this.__attr(`input`) }
  get undo() { return this.__attr(`undo`) }
  get redo() { return this.__attr(`redo`) }
  get status() { return this.__attr(`status`) }
  get failReason() { return this.__attr(`failReason`) }
  get receivedAt() { return this.__attr(`receivedAt`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get startDate() { return this.__attr(`startDate`) }
  get endDate() { return this.__attr(`endDate`) }
}
export function selectFromEngineActionDto() {
  return new EngineActionDtoModelSelector()
}

export const engineActionDtoModelPrimitives = selectFromEngineActionDto().actionUuid.name.projectId.userUuid.input.undo.redo.status.failReason.receivedAt.createdAt.organizationId.startDate.endDate
